import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { ProfileAssabilMenu } from './profile-assabil-menuentity';


export class Profile extends BaseEntity {

    profileCode         : string;
    name                : string;

    profileAssabilMenus : ProfileAssabilMenu[];

}